(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.site-header').forEach((header) => {
    const menuButton = header.querySelector('.menu-toggle');
    const nav = header.querySelector('.site-nav');
    const closeMenu = () => {
      nav?.classList.remove('is-open');
      menuButton?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    };
    menuButton?.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      nav?.classList.toggle('is-open', !open);
      document.body.classList.toggle('menu-open', !open);
    });
    header.querySelector('[data-menu-close]')?.addEventListener('click', closeMenu);
    const search = header.querySelector('.header-search');
    const toggle = header.querySelector('[data-search-toggle]');
    const openSearch = () => {
      search.hidden = false;
      toggle?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => search.querySelector('input')?.focus());
    };
    const closeSearch = () => {
      search.hidden = true;
      toggle?.setAttribute('aria-expanded', 'false');
    };
    toggle?.addEventListener('click', () => search.hidden ? openSearch() : closeSearch());
    header.querySelector('[data-search-close]')?.addEventListener('click', closeSearch);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu();
        closeSearch();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero__video').forEach((video) => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const updatePlayback = () => {
      if (reducedMotion.matches) {
        video.pause();
      } else {
        video.play().catch(() => {});
      }
    };
    const showVideo = () => video.classList.add('is-ready');
    if (video.readyState >= 3) showVideo();
    video.addEventListener('canplay', showVideo, { once: true });
    updatePlayback();
    reducedMotion.addEventListener('change', updatePlayback);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('.collection-main').forEach((section) => {
    const drawer = section.querySelector('.collection-filters');
    const toggle = section.querySelector('.filter-toggle');
    const close = () => {
      drawer?.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    };
    toggle?.addEventListener('click', () => {
      drawer?.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
    });
    section.querySelector('[data-filter-close]')?.addEventListener('click', close);
    const active = section.querySelectorAll('.active-filters a').length;
    const count = section.querySelector('[data-active-count]');
    if (count && active) count.textContent = active;
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-media-index]')];
    const thumbs = [...root.querySelectorAll('[data-thumb-index]')];
    const dialog = document.querySelector('[data-media-dialog]');
    const content = dialog?.querySelector('[data-dialog-content]');
    const activate = (index) => {
      slides.forEach((item, i) => item.classList.toggle('is-active', i === index));
      thumbs.forEach((item, i) => item.classList.toggle('is-active', i === index));
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => activate(Number(thumb.dataset.thumbIndex))));
    slides.forEach((slide) => slide.querySelector('[data-open-image]')?.addEventListener('click', () => {
      const image = slide.querySelector('img');
      if (!image || !dialog || !content) return;
      content.replaceChildren(image.cloneNode());
      dialog.showModal();
    }));
    dialog?.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    root.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
      const select = event.currentTarget;
      root.querySelector('[data-price]').textContent = select.options[select.selectedIndex].dataset.price;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
